import { UpdatePaymentItem } from '@src/types/payment';
import { PaymentRefundParams, PaymentsHisoryParams } from './payment';
import { oliveApi } from '../index';

const url = `/admin/v1/payments`;

export const getPaymentsHistoryApi = async (params: PaymentsHisoryParams) => {
  return await oliveApi.GET<PaymentsHisoryParams, any>(`${url}`, params);
};

export const createPaymentApi = async ({
  projectId,
  promotionId,
  companyCouponId,
}: {
  projectId: string;
  promotionId?: string;
  companyCouponId?: string;
}) => {
  return oliveApi.POST<any, any>(`${url}`, {
    projectId,
    promotionId,
    companyCouponId,
  });
};

export const updatePaymentByIdApi = async ({
  paymentId,
  paymentItems,
}: {
  paymentId: string;
  paymentItems: UpdatePaymentItem[];
}) => {
  return oliveApi.PATCH<any, any>(`${url}/${paymentId}`, { paymentItems });
};

export const previewPaymentByIdApi = async ({
  paymentId,
  paymentItems,
}: {
  paymentId: string;
  paymentItems: UpdatePaymentItem[];
}) => {
  return oliveApi.PATCH<any, any>(`${url}/${paymentId}/preview`, {
    paymentItems,
  });
};

export const getPaymentByIdApi = async ({
  paymentId,
}: {
  paymentId: string;
}) => {
  return oliveApi.GET<any, any>(`${url}/${paymentId}`);
};

export const refundPaymentByIdApi = async ({
  paymentId,
  amount,
  note,
}: PaymentRefundParams) => {
  return oliveApi.PATCH(`${url}/${paymentId}/refund`, { amount, note });
};
